// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tchz","rootNoMargin":"styles_rootNoMargin__29FoI"};